import sanityClient from "@sanity/client";
import ImageUrlBuilder from "@sanity/image-url";
// import { ImageUrlBuilder } from "@sanity/image-url/lib/types/builder";

export const client = sanityClient({
  projectId: "sgj7m64m",
  apiVersion: "2022-04-11",
  dataset: "production",
  useCdn: true,
  token: process.env.REACT_APP_CLIENT_API,
});
const builder = ImageUrlBuilder(client);
export const urlFor = (source) => builder.image(source);
